
    const data = {"name":"src/core/icons/clock","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2m4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            